module.exports = __webpack_public_path__ + "img/slider-3.e285c768.jpeg";